import { render, staticRenderFns } from "./goodsTablePage.vue?vue&type=template&id=073432aa&scoped=true&"
import script from "./goodsTablePage.vue?vue&type=script&lang=js&"
export * from "./goodsTablePage.vue?vue&type=script&lang=js&"
import style0 from "./goodsTablePage.vue?vue&type=style&index=0&id=073432aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073432aa",
  null
  
)

export default component.exports